import React from 'react';
import { FaShieldHalved, FaIndianRupeeSign, FaCircleCheck } from 'react-icons/fa6'; 
import './why-trust-us.css'; 

const WhyTrustUsGeom = () => {
    
    const trustPoints = [
        {
            icon: <FaShieldHalved />,
            title: "1. Secure & Encrypted Process",
            description: "We prioritize your privacy and security, using advanced encryption to protect all your personal and financial data.",
            accent: "geom-green",
            colorCode: '#1a1a1a'
        },
        {
            icon: <FaIndianRupeeSign />,
            title: "2. Transparent & Fair Verification",
            description: "Our transparent verification ensures fair assessment of your loan eligibility without hidden terms or delays.",
            accent: "geom-magenta",
            colorCode: '#00e676'
        },
        {
            icon: <FaCircleCheck />,
            title: "3. Instant & Reliable Disbursal",
            description: "Once approved, your funds are quickly and reliably transferred, enabling you to achieve your financial goals effortlessly.",
            accent: "geom-blue",
            colorCode: '#e040fb'
        },
    ];

    return (
        <section className="why-trust-us-section geom-design-bg">
            <div className="container trust-container">
                
                {/* Section Heading */}
                <h2 className="trust-section-heading">
                    Why <span className="accent-green-mv">Salaried</span> <span className="accent-magenta-mv">Professionals</span> Trust Us
                </h2>
                
                {/* Section Paragraph */}
                <p className="trust-subtitle">
                    Our Ultra Short Term Loan solutions — secure, transparent, and fast — have earned the trust of thousands of employees across India.
                </p>
                
                {/* Flow Line */}
                <div className="geom-flow-line-wrapper">
                    <div className="geom-flow-line"></div> 
                </div>

                {/* Cards Grid */}
                <div className="trust-grid geom-grid">
                    {trustPoints.map((item, index) => (
                        <div 
                            className={`trust-card geom-card ${item.accent}`} 
                            key={index}
                            style={{ '--accent-color': item.colorCode }}
                        >
                            <div className="flow-dot-connector"></div> 
                            
                            <div className="card-content-inner">
                                <div className={`trust-icon-wrapper ${item.accent}`}>
                                    {item.icon}
                                </div>
                                
                                <h3 className="trust-title">{item.title}</h3>
                                
                                <p className="trust-description">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className="section-divider-geom"></div>
        </section>
    );
};

export default WhyTrustUsGeom;
